module.exports = __webpack_public_path__ + "img/8.f19fe3d9.jpg";